import React, {
  forwardRef,
  SyntheticEvent,
  PropsWithChildren,
  ComponentProps,
  ForwardedRef,
} from 'react';

import { ButtonLinkColor, ButtonLinkSize } from './constants';

import { StyledButtonLink } from './styles';

interface IButtonLinkProps extends PropsWithChildren {
  className?: string;
  color?: ButtonLinkColor;
  size?: ButtonLinkSize;
  disabled?: boolean;
  type?: ComponentProps<'button'>['type'];
  as?: 'button' | 'a';
  href?: string;
  download?: boolean;
  target?: string;
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void;
}

export const ButtonLink = forwardRef(({
  className,
  color = ButtonLinkColor.PRIMARY,
  size = ButtonLinkSize.MEDIUM,
  type = 'button',
  disabled = false,
  as = 'button',
  href,
  download = false,
  target,
  onClick,
  children,
}: IButtonLinkProps, ref: ForwardedRef<HTMLButtonElement>) => {
  return (
    <StyledButtonLink
      ref={ref}
      className={className}
      color={color}
      size={size}
      type={type}
      disabled={disabled}
      onClick={onClick}
      as={as}
      // @ts-ignore ONLY LINK PROPS GO UNDER ts-ignore
      href={href}
      download={download}
      target={target}
    >
      {children}
    </StyledButtonLink>
  );
});
